import React from 'react';
import { GeneralParameterInput } from '../common/ParameterInput';
import { GeneralParameterDefinition } from '../../types';

interface GeneralParametersProps {
  parameters: GeneralParameterDefinition[];
  values: Record<string, any>;
  onChange: (id: string, value: any) => void;
  disabled?: boolean;
}

/**
 * Component for displaying and editing general simulation parameters
 */
export const GeneralParameters: React.FC<GeneralParametersProps> = ({
  parameters,
  values,
  onChange,
  disabled = false
}) => {
  return (
    <div className="general-parameters">
      <div className="parameters-header">
        <div className="parameter-column">Parameter</div>
        <div className="parameter-column">Mean / Value</div>
        <div className="parameter-column">Std Dev</div>
        <div className="parameter-column">Units</div>
      </div>
      
      {parameters.map((parameter) => (
        <GeneralParameterInput
          key={parameter.id}
          parameter={parameter}
          value={values[parameter.id]}
          onChange={onChange}
          disabled={disabled}
        />
      ))}
    </div>
  );
};
